/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * What became of the exercise. Only SKIPPED is accepted today; other EnEventStatus values are rejected with a 400.
 * @export
 * @enum {string}
 */
export enum EnEventExerciseStatus {
    SKIPPED = 'SKIPPED'
}

